import { Button, Dropdown } from '@/components';
import { DownOutlined } from '@ant-design/icons';
import type { ComponentProps, FC } from 'react';
import { useTranslation } from 'react-i18next';

type Props = {
  text?: string;
} & Pick<ComponentProps<typeof Dropdown>, 'menu' | 'disabled'>;

export const BulkActionsDropdown: FC<Props> = ({
  disabled = false,
  menu,
  text,
}) => {
  const { t } = useTranslation();

  return (
    <Dropdown disabled={disabled} menu={menu}>
      <Button icon={<DownOutlined />} iconPosition="end">
        {text || t('bulk-operation')}
      </Button>
    </Dropdown>
  );
};
